"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _traverse = _interopRequireDefault(require("traverse"));

var _lodash = require("lodash");

var _prismicJavascript = _interopRequireDefault(require("prismic-javascript"));

var PrismicPreviewWrapper =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(PrismicPreviewWrapper, _React$Component);

  function PrismicPreviewWrapper() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, PrismicPreviewWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(PrismicPreviewWrapper)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      data: _this.props.data
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "url", new URL(window.location.toString()));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "qs", _this.url.searchParams);
    return _this;
  }

  (0, _createClass2.default)(PrismicPreviewWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setup();
    }
  }, {
    key: "setup",
    value: function () {
      var _setup = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee() {
        var documentId, targetId, data, prismicIds, api, previews, updateWithPreview;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                documentId = this.qs.get('documentId');
                targetId = this.qs.get('targetId');
                data = (0, _objectSpread2.default)({}, this.props.data);

                if (!this.qs.has('preview')) {
                  _context.next = 15;
                  break;
                }

                prismicIds = (0, _traverse.default)(data).reduce(function (acc) {
                  if (this.key === 'prismicId' && this.parent && acc.indexOf(this.parent.node.prismicId) === -1) {
                    acc.push(this.parent.node.prismicId);
                  }

                  return acc;
                }, []);

                if (prismicIds.indexOf(documentId) === -1) {
                  prismicIds.push(documentId);
                }

                _context.next = 8;
                return _prismicJavascript.default.getApi("https://".concat(this.props.repositoryName, ".cdn.prismic.io/api/v2"));

              case 8:
                api = _context.sent;
                _context.next = 11;
                return Promise.all(prismicIds.map(function (prismicId) {
                  return api.getByID(prismicId);
                }));

              case 11:
                previews = _context.sent;

                // Update the object with a match from preview (if available)
                updateWithPreview = function updateWithPreview(obj) {
                  var id = obj.id === targetId ? documentId : obj.id;
                  var preview = previews.find(function (p) {
                    return p.id === id;
                  });
                  return (0, _traverse.default)(obj).map(function (x) {
                    if (this.key === 'localFile') {
                      // TODO: traverse all localfiles and replace sharp urls with the external prismic image
                      this.remove();
                    }

                    if (this.key === 'dataString') {
                      this.update(JSON.stringify(preview.data));
                    }

                    if (this.key === 'raw' && (0, _lodash.isArray)(x)) {
                      var paths = this.path.slice(0);
                      paths.pop();
                      this.update((0, _lodash.get)(preview, paths.join('.')), true);
                    }

                    if (this.isLeaf) {
                      var previewValue = (0, _lodash.get)(preview, this.path.join('.'));

                      if (previewValue) {
                        this.update(previewValue);
                      }
                    }
                  });
                }; // Traverse all objects that have `prismicId` in them


                (0, _traverse.default)(data).forEach(function (x) {
                  if ((0, _lodash.get)(x, 'prismicId')) {
                    this.update(updateWithPreview(x));
                  }
                });
                this.setState({
                  data: data
                });

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function setup() {
        return _setup.apply(this, arguments);
      };
    }()
  }, {
    key: "render",
    value: function render() {
      return _react.default.cloneElement(this.props.children, {
        data: this.state.data
      });
    }
  }]);
  return PrismicPreviewWrapper;
}(_react.default.Component);

exports.default = PrismicPreviewWrapper;